/* eslint-disable no-undef */
/* eslint-disable no-constant-condition */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Fragment, useCallback, useEffect, useState } from 'react';
import React from 'react';
import { Button, InputLabel, RadioGroup, Radio, Table, TableBody, TableContainer, Paper, Grid, Checkbox, FormControlLabel, Box } from '@mui/material';
import { chWtMultiplier } from '../../constants/global-constants';

export const PaymentDetails = ({ userInfo, selectedShipping }) => {

    const getTotalHmdCond = () => {
        var paymentDate = selectedShipping.paymentDate;
        if (selectedShipping.originalPaymentData)
            if (selectedShipping.originalPaymentData === "new")
                paymentDate = null;
        if (paymentDate) {
            var totalInvoice_nis = Number(selectedShipping.params?.transportVal_nis ? selectedShipping.params?.transportVal_nis : 0)
                + Number(selectedShipping.params?.purchaseTax_nis ? selectedShipping.params?.purchaseTax_nis : 0)
                + Number(selectedShipping.params?.customsCharge_nis ? selectedShipping.params?.customsCharge_nis : 0)
                + Number(selectedShipping.params?.vat_nis ? selectedShipping.params?.vat_nis : 0)
                + Number(selectedShipping.params?.addCharges_nis ? selectedShipping.params?.addCharges_nis : 0)
                + Number(selectedShipping.params?.fixedFee_nis ? selectedShipping.params?.fixedFee_nis : 0)
                + Number(selectedShipping.params?.storageCost_nis ? selectedShipping.params?.storageCost_nis : 0)
                + Number(selectedShipping.params?.returnToShipper_nis ? selectedShipping.params?.returnToShipper_nis : 0)
                + Number(selectedShipping.params?.isInsurence ? selectedShipping.params?.insurence_nis : 0);
            if (totalInvoice_nis < selectedShipping.params?.finalAmount_nis)
                return true;
        }
        var wt = Number(selectedShipping.params?.userPaymentData?.weight);
        var h = Number(selectedShipping.params?.userPaymentData?.height);
        var l = Number(selectedShipping.params?.userPaymentData ? selectedShipping.params?.userPaymentData["length"] : 0);
        var w = Number(selectedShipping.params?.userPaymentData?.width);

        var chargWt = Number(h) * Number(l) * Number(w) * chWtMultiplier;

        var twt = Number(chargWt > wt ? chargWt : wt);
        if (twt > 4) return false;
        return true;
    }
    const getSurcharge = (ship) => {
        var total = ship?.params?.finalAmount ? Number(ship.params.finalAmount) : 0;
        if (!ship.params.costSurcharge) {
            if (total <= 100)
                return 0;
            else if (total > 100 && total < 500)
                return 6;
            else if (total >= 500 && total < 1000)
                return 20;
            return 25;
        } else
            return ship.params.costSurcharge;
    }
    const getSurchargeFromNis = (ship) => {
        if (ship?.params?.costSurcharge_nis && ship?.params?.finalAmount_nis) {
            return Number(Number(ship.params.costSurcharge_nis) * Number(ship.params.finalAmount) / Number(ship.params.finalAmount_nis)).toFixed(2);
        }
    }
    function isNumeric(val) {
        return !isNaN(val) && !isNaN(parseFloat(val));
    }
    const getRescanCost = (data) => {
        if (selectedShipping?.params?.totalRescanCost)
            return selectedShipping?.params?.totalRescanCost;
        if (isNumeric(data)) {
            return data;
        }
        var total = 0;
        Object.keys(data).map(key => { total += ((key != undefined && key != "undefined") ? Number(data[key]) : 0) })
        return total;
    }
    const getTotalHmdValue = () => {
        if (selectedShipping?.params?.homeDelivary_acc)
            return Number(selectedShipping?.params?.homeDelivary_acc).toFixed(2);
        if (selectedShipping?.paymentDate) {
            if (selectedShipping.paymentDate > 1735693200000 && selectedShipping.paymentDate < 1765255536000) {
                return 4.72;
            }
            else if (selectedShipping.paymentDate > 1765255536000 && selectedShipping.paymentDate < 1772154000000) {
                return 4;
            }
            else if (selectedShipping.paymentDate > 1772154000000) {
                return 6;
            }
        }
        return 4.68;
    }
    return (
        <Grid item container>
            {<Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '10px', direction: 'rtl' }}>

                {(selectedShipping.params.couponText && Number(selectedShipping.params.couponDeduction) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`קופון`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        {selectedShipping.params.couponText}:  -{selectedShipping.params.couponDeduction}$
                    </Grid>
                </Grid> : <span></span>}
                {(selectedShipping.params.transportVal && Number(selectedShipping.params.transportVal) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`שילוח`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.transportVal).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {(selectedShipping.params.customsCharge && Number(selectedShipping.params.customsCharge) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`מכס כללי`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.customsCharge).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {(selectedShipping.params.purchaseTax && Number(selectedShipping.params.purchaseTax) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`מס קניה`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.purchaseTax).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {(selectedShipping.params.aCUsed && Number(selectedShipping.params.aCUsed) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`חיובים נוספים`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.aCUsed).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {(selectedShipping.params.additionalCharges_acc && Number(selectedShipping.params.additionalCharges_acc) != 0 && !selectedShipping.params.aCUsed) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`חיובים נוספים`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.additionalCharges_acc).toFixed(2)}
                    </Grid>
                </Grid> : ((selectedShipping.params.additionalCharges && Number(selectedShipping.params.additionalCharges) != 0 && !selectedShipping.params.aCUsed) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`חיובים נוספים`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                            $ {Number(selectedShipping.params.additionalCharges).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>)}
                {(selectedShipping.params.costSurcharge && Number(selectedShipping.params.costSurcharge) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`אגרת מחשב ובטחון`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.costSurcharge).toFixed(2)}
                    </Grid>
                </Grid> : <span style={{width: "100%"}}>{(selectedShipping.params.costSurcharge_nis && Number(selectedShipping.params.costSurcharge_nis) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`אגרת מחשב ובטחון`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                            $ {getSurchargeFromNis(selectedShipping)}
                    </Grid>
                </Grid> : <span></span>}</span>}
                {(selectedShipping.params.vat && Number(selectedShipping.params.vat) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`מע"מ`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.vat).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {selectedShipping.params.isInsurence ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`ביטוח`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.insurence).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {(selectedShipping.params.homeDelivary && getTotalHmdCond()) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`הפצה עד הבית`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {getTotalHmdCond() ? getTotalHmdValue() : 0}
                    </Grid>
                </Grid> : <span></span>}
                {/*{selectedShipping.params.couponText && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ }}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{ }}>
                        {`קופון`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{ }}>
                        {Number(selectedShipping.params.couponDeduction).toFixed(2)} $
                    </Grid>
                </Grid>}*/}
                {(selectedShipping.params.storageCost && Number(selectedShipping.params.storageCost) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`אחסנה`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.storageCost).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {(selectedShipping.params.repackCost && Number(selectedShipping.params.repackCost) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`אריזה מחדש`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping?.params?.totalRepackCost ? selectedShipping?.params?.totalRepackCost : selectedShipping.params.repackCost).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {(selectedShipping.params.rescanCost && getRescanCost(selectedShipping.params.rescanCost) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`צילום תכולה`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(getRescanCost(selectedShipping.params.rescanCost)).toFixed(2)}
                    </Grid>
                </Grid> : <>{(selectedShipping.params.rescanCostVal && getRescanCost(selectedShipping.params.rescanCostVal) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`צילום תכולה`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                            $ {Number(getRescanCost(selectedShipping.params.rescanCostVal)).toFixed(2)}
                    </Grid>
                </Grid> : <></>}</>}
                {(selectedShipping.params.consolidationCharges && Number(selectedShipping.params.consolidationCharges) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`איחוד חבילות`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.consolidationCharges).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {(selectedShipping.params.fixedFee && Number(selectedShipping.params.fixedFee) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`טיפול באישורים`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.fixedFee).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {/*{(selectedShipping.params.fixedFee && getSurcharge(selectedShipping) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`אגרת מחשב`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(getSurcharge(selectedShipping)).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}*/}
                {(selectedShipping.params.selfClearance && Number(selectedShipping.params.selfClearance) != 0) ? <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{}}>
                        {`שחרור פרטני`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{}}>
                        $ {Number(selectedShipping.params.selfClearance).toFixed(2)}
                    </Grid>
                </Grid> : <span></span>}
                {selectedShipping.params.returnToShipper && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ }}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{ }}>
                        {`החזרה לספק`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{ }}>
                        $ {Number(selectedShipping.params.returnToShipper).toFixed(2)}
                    </Grid>
                </Grid>}
                {selectedShipping.params.finalAmount && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', borderTop: '1px solid gray' }}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                        {`סה״כ לתשלום`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                        $ {Number(selectedShipping.params.finalAmount).toFixed(2)}
                    </Grid>
                </Grid>}
                {selectedShipping.params.finalAmount && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', borderTop: '1px solid gray' }}>
                    <Grid container item lg={7} xs={7} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                        {`תשלום בשקלים`}
                    </Grid>
                    <Grid container item lg={5} xs={5} justifyContent="flex-end" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                        {`₪`} {Number(selectedShipping.params.finalAmount_nis).toFixed(2)}
                    </Grid>
                </Grid>}
            </Grid>}
        </Grid>
    );
}

export default PaymentDetails;